<template>
   <div class="w-auto h-auto">
    <img :src="imgUrl" class="w-full h-full rounded-2xl" alt="" >
  </div>
</template>

<script>
export default {

   data()  {
      return {
        imgUrl: new URL('@/assets/Welcome4.png', import.meta.url).href
      }
    }

}
</script>

<style>

</style>